import { AppRegions } from 'app-constants';

export const isAppRegion = (region: string): region is AppRegions => {
  return Object.values(AppRegions).includes(region as AppRegions);
};
